import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, message, Modal, Row, Select } from "antd";

import { justificationsService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
} from "./../../components";

import { JUSTIFICATION_TYPES, JustificationsInfoBanner, JustificationStatusField } from "./create";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

class Edit extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isSending: false,
			uuid: 0,
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
		});

		justificationsService.show({ uuid })
			.then((response) => {
				const item = response.data.data;

				this.setState({
					isLoading: false,
				}, () => {
					// Fill form
					this.fillForm(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	fillForm = (data) => {
		this.form.setFieldsValue({
			nome: data.nome,
			acao: data.acao,
			ativo: data.ativo == 1,
		});
	};

	onClose = () => {
		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		this.setState({
			isSending: true,
		});

		const data = {
			...values,
			uuid: this.state.uuid,
		};

		justificationsService.edit(data)
			.then((response) => {
				this.setState({
					isSending: false,
				});

				// Success message
				message.success("Registro atualizado com sucesso.");

				// Callback
				this.props.onComplete();
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	render() {
		const { visible } = this.props;

		const { isLoading, isSending } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-file-alt" />}
				title="Editar justificativa"
				subtitle="Atualize as informações da justificativa.">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}>
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
						description="Nome e efeito da justificativa no ponto.">
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item name="nome" label="Nome" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Input placeholder="Digite o nome da justificativa" />
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item name="acao" label="Tipo" rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Select
										optionFilterProp="children"
										filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
										allowClear
										placeholder="Selecione o tipo de justificativa"
										showSearch>
										{Object.entries(JUSTIFICATION_TYPES).map(([value, label]) => (
											<Select.Option key={value} value={value}>{label}</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<JustificationStatusField />
							</Col>
						</Row>
					</UIFormSection>
					<JustificationsInfoBanner />
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Edit;
